import React, { FC } from 'react';
import { formatMoney } from 'Shared/utils/number/number';
import { formatDateShort } from 'Shared/utils/date/date';
import { CalculatePaymentPlanResponse } from '@clearcover/core-app-types';
import styles from './styles.module.css';

export type PaymentScheduleListProps = {
  paymentPlan: CalculatePaymentPlanResponse | null;
};

export const PaymentScheduleList: FC<PaymentScheduleListProps> = ({
  paymentPlan,
}) => {
  if (!paymentPlan || !paymentPlan.installments.length) {
    return null;
  }

  const dueInstallments = paymentPlan.installments.filter(
    (installment: CalculatePaymentPlanResponse['installments'][0]) =>
      installment.status === 'DUE'
  );
  const halfLength = Math.ceil(dueInstallments.length / 2);
  const leftInstallments = dueInstallments.slice(0, halfLength);
  const rightInstallments = dueInstallments.slice(halfLength);

  const renderInstallmentRow = (
    installment: CalculatePaymentPlanResponse['installments'][0]
  ) => (
    <div key={installment.sequenceNumber} className={styles.installmentRow}>
      <span className={styles.installmentDate}>
        {formatDateShort(installment.dueDate)}
      </span>
      <span className={styles.installmentAmount}>
        {formatMoney(installment.amount.value)}
      </span>
    </div>
  );

  return (
    <div className={styles.paymentScheduleSection}>
      <h3>New payment schedule</h3>
      <div className={styles.paymentScheduleContainer}>
        <div className={styles.paymentScheduleColumn}>
          {leftInstallments.map(renderInstallmentRow)}
        </div>
        <div className={styles.paymentScheduleColumn}>
          {rightInstallments.map(renderInstallmentRow)}
        </div>
      </div>
    </div>
  );
};
